import { useEffect } from "react";

/**
 * Force admin routes to be invisible to search engines.
 * Sets <meta name="robots" content="noindex, nofollow"> while mounted,
 * and restores the previous value when unmounted.
 */
export default function NoIndex({ enabled = true }) {
  useEffect(() => {
    if (!enabled) return undefined;
    let el = document.head.querySelector('meta[name="robots"]');
    const created = !el;
    const previous = el ? el.getAttribute("content") : null;
    if (!el) {
      el = document.createElement("meta");
      el.setAttribute("name", "robots");
      document.head.appendChild(el);
    }
    el.setAttribute("content", "noindex, nofollow, noarchive, nosnippet");

    return () => {
      if (created) {
        el.remove();
      } else if (previous != null) {
        el.setAttribute("content", previous);
      }
    };
  }, [enabled]);
  return null;
}
